<div class="wrapper" [ngClass]="{ disabled: isDisabled }" [attr.tabindex]="isDisabled ? -1 : 0" (click)="handleClick()" (keydown.enter)="handleClick()">
  <div class="tile-body">
    <div class="icon-wrapper">
      <svg-icon [src]="icon" class="selected-icon"></svg-icon>
    </div>

    <div class="gains-tiles-header">{{ title }}</div>
    <div class="gains-tiles-content">{{ content }}</div>
  </div>

  <div class="tile-footer" *ngIf="showFooter" [ngClass]="{ 'no-divider': !showFooterDivider }">
    <div class="status" *ngIf="showStatus" [ngClass]="{ inactive: isStatusInactive }">
      <span class="status-indicator">
        <span *ngIf="!isDisabled" class="status-dot"></span>
        <svg-icon *ngIf="isDisabled" class="lock-icon" src="assets/icons/ti-lock.svg"></svg-icon>
      </span>
      <span class="status-text">{{ statusLabel }}</span>
    </div>
    <span class="chevron">&#8250;</span>
  </div>
</div>
